var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g(_vm._b({ref:_vm.data.ref,staticClass:"jz-card",class:[
    _vm.data.class,
    _vm.data.staticClass,
    {
      'layout-standard': _vm.props.layoutStandard,
      'layout-flex': _vm.props.layoutFlex
    }
  ]},'div',_vm.data.attrs,false),_vm.listeners),[(_vm.slots()['header'] !== undefined)?_c('header',{staticClass:"jz-card-header"},[_vm._t("header")],2):_vm._e(),_vm._t("default"),(_vm.slots()['footer'] || _vm.slots()['footer-buttons'])?_c('footer',{staticClass:"jz-card-footer"},[_vm._t("footer"),(_vm.slots()['footer-buttons'] !== undefined)?_c('div',{staticClass:"jz-button-group column-on-small-screen"},[_vm._t("footer-buttons")],2):_vm._e()],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }